/* eslint-disable camelcase */
/* eslint-disable no-bitwise */
import { getSourceType } from 'src/dictionaries/SourceType';
import { ANALYTICS_EVENT } from 'src/interfaces/enums';
import { IVideoJSPlayer } from 'src/interfaces/VideoJS';

export const muxEmit = (player: IVideoJSPlayer) => {
  setTimeout(() => {
    const currentSource = player.currentSource();
    const sourceType = getSourceType(currentSource.type || 'undefined');
    const custom_3 = JSON.stringify({ sourceType: sourceType });
    return player?.mux.emit(ANALYTICS_EVENT.LOAD_START, {
      custom_3,
    });
  }, 2000);
};
